<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import LeagueBreadcrumbs from '@/components/widgets/public/LeagueBreadcrumbs.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { getErrorMessage } from '@/utils/error-handling'

const leagues = useLeaguesStore()
const route = useRoute()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(true)

async function onRouteChange() {
  errorMessage.value = null
  isLoading.value = true

  const season = (route.params.season as string) ?? null
  const leagueId = (route.params.id as string) ?? null

  try {
    leagues.selectSeason(season)
    await leagues.selectLeagueById(leagueId)
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed selecting season or league: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
}

watch(() => route.path, onRouteChange)

onMounted(async () => {
  await onRouteChange()
})
</script>

<template>
  <main>
    <template v-if="!isLoading">
      <h1 class="noprint">{{ $t('leagues.view-title') }}</h1>
      <LeagueBreadcrumbs />
      <RouterView />
    </template>

    <NotificationBanner
      v-else-if="errorMessage"
      :message="errorMessage"
      is-danger
    />
  </main>
</template>

<style lang="scss" scoped>
main {
  user-select: text;
}
</style>
